import {
  getUnifiedString,
} from "@vsimple/vsimple-ui"

type UserAccount = {
  id: string | number
  firstName: string
  lastName: string
  email: string
  avatar: string | null
  isActive: boolean
  status: string
}

type CompanyAccount = {
  id: string | number
}

type UserResponseItem = {
  account: UserAccount
  companyAccount: CompanyAccount
  tags: unknown[]
}

type MappedUser = {
  accountIdValue: string
  value: string
  label: string
  status: string
  avatar: string | null
  email: string
  firstName: string
  lastName: string
  initials: string
  isActive: boolean
}

export default function userResponseMapper(response: UserResponseItem[]): MappedUser[] {

  return response.map((user) => {
    return {
      ...user.account,
      ...user.companyAccount,
      id: user.account.id,
      accountId: user.companyAccount.id,
      tags: user.tags,
    }
  }).filter((user) => Object.keys(user).length).map((user) => {
    return {
      accountIdValue: String(user.accountId),
      value: String(user.id),
      label: getUnifiedString([user.firstName, user.lastName]),
      status: user.status,
      avatar: user.avatar,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      initials: String(user.firstName)[0].toUpperCase() + String(user.lastName)[0].toUpperCase(),
      isActive: user.isActive,
    }
  })
}
